module.exports = __webpack_public_path__ + "img/20180815_150119_063.e13d8bc7.jpg";